// RecipesList.js
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  useRecordContext,
} from 'react-admin';

const RecipesList = () => (
  <List resource="recipes">
    <Datagrid>
        <TextField source="Name"  label = "Nome"/>
        <TextField source="CreatedDate" label = "Dta. Criação"/>
        <TextField source="CreatedBy" label = "Criada por"/>
        <TextField source="ModifiedDate" label = "Dta. Edição"/>
        <TextField source="ModifiedBy" label = "Editada por"/>
        <TextField source="AverageRating" label = "Pontuação Média"/>
    </Datagrid>
  </List>
);



export default RecipesList;
